<template>
  <div>
    <div
      v-for="(e, index) in otherContractData"
      :key="index"
      class="otherContractList"
    >
      <div class="otherContractContent otherContractTop">
        <div class="title">授权协议</div>
        <div
          class="contract"
          @click="clickContract(e.id)"
        >《{{e.contractMessage}}》</div>
      </div>
      <div class="otherContractContent">
        <div class="title">签订时间</div>
        <div class="time">{{e.createTime}}</div>
      </div>
    </div>
    <my-popup
      :contractId="contractId"
      v-model="isShowPopup"
    />
  </div>
</template>

<script>

import MyPopup from '@/components/myPopupContract.vue';

export default {
  name: 'OtherContractList',
  data() {
    return {
      isShowPopup: false,
      contractId: '',

    };
  },
  components: {
    MyPopup,
  },
  props: ['otherContractData'],
  methods: {
    clickContract(e) {
      this.isShowPopup = true;
      this.contractId = e;
    },
  },
};
</script>
<style scoped>
.otherContractList {
  padding: 8px 16px;
  background: #fff;
  position: relative;
}
.otherContractList::after {
  position: absolute;
  right: 16px;
  bottom: 0;
  left: 16px;
  box-sizing: border-box;
  border-bottom: 1px solid #dddee1;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  content: " ";
  pointer-events: none;
}
.otherContractContent {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.otherContractTop {
  margin-bottom: 24px;
}
.contract {
  font-family: PingFangSC-Regular;
  font-size: 15px;
  color: #ff6538;
}
.title {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #495060;
}
.time {
  font-family: PingFangSC-Regular;
  font-size: 15px;
  color: #001f33;
}
</style>
